import React, { Fragment, useEffect } from "react";

import { Overflow, ResponsiveDimension } from "../../../types";
import { IconButton } from "../../controls";
import { Box } from "../../layout";
import Overlay from "../Overlay";
import ContentBox from "./components/ContentBox";
import { MaxWidth } from "./components/ContentBox/consts";

export type ModalProps = {
  children: React.ReactNode;
  partOfJourney?: boolean;
  inContainer?: boolean;
  onCloseClick?: () => void;
  padding?: ResponsiveDimension;
  maxWidth?: MaxWidth;
  fullscreenOnMobile?: boolean;
  background?: string;
  scrollable?: boolean;
  overflowY?: Overflow;
};

export default function Modal({
  children,
  partOfJourney = false,
  inContainer = false,
  onCloseClick,
  padding = "xxlarge",
  maxWidth = "medium",
  fullscreenOnMobile = false,
  background,
  scrollable = true,
  overflowY
}: ModalProps) {
  useEffect(() => {
    if (!inContainer && document.body && document.body.style) {
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = "auto";
      };
    }
    return;
  }, []);

  const contentProps = {
    inContainer,
    padding,
    maxWidth,
    fullscreenOnMobile,
    background,
    scrollable,
    overflowY
  };

  const contentBox = (
    <ContentBox {...contentProps}>
      {onCloseClick && (
        <Box position="absolute" top="0" right="0">
          <IconButton
            iconName="cross"
            accessibilityLabel="Close modal"
            onClick={onCloseClick}
            size="medium"
            tone="neutral"
            blend
          />
        </Box>
      )}
      {children}
    </ContentBox>
  );

  return partOfJourney ? (
    contentBox
  ) : (
    <Fragment>
      <Overlay
        onCloseClick={onCloseClick}
        position={inContainer ? "absolute" : "fixed"}
      />
      {contentBox}
    </Fragment>
  );
}
